import './Header.css'
import { useLocation, useNavigate} from 'react-router-dom'
import { useStateValue } from '../../stateProvider/stateProvider';
import { LOGOUT, SET_CHOOSEN_TABLE } from '../../constans/reducerActions';
import { WIZUALIZACJE,ZAKODOWANE } from '../../constans/tableCalls';


const Header = ({name = "User",img = './Images/userIco.png'}) => {
    const navigate = useNavigate();
    const location = useLocation()
    const [{role,choosenTable},dispatch] = useStateValue()

    const logOut = () => {
        dispatch({type:LOGOUT})
        //navigate('/login')
    }

    console.log(location.pathname)

    const changeTable = () => {
        let chosen;

        if(choosenTable === WIZUALIZACJE)
            chosen = ZAKODOWANE
        else 
            chosen = WIZUALIZACJE;

        dispatch({
            type:SET_CHOOSEN_TABLE,
            item: chosen
        })

        
    }


    return (
        <header className='header'>
            <img src="./Images/logo.png" className='header__logo' onClick={() => navigate('/')} />
            
            {
            location.pathname === '/panel' &&
            <div onClick={changeTable} className="header__change-table">
                <span
                    className={(choosenTable === WIZUALIZACJE) ? "header__active-panel-name" : "header__no-active-panel-name"}
                >
                    Kreacje statyczne
                </span>
                <span
                    className={(choosenTable === ZAKODOWANE) ? "header__active-panel-name" : "header__no-active-panel-name"}
                >
                    Kreacje zakodowane
                </span>
            </div>
            }
            <div className='header__user-info'>
              
                <h3 className='header__user-role'>
                    {name ? name : ""}
                </h3>
                <img src={img} className='header__user-icon' />
                <button className='header-btn' onClick={logOut}>Wyloguj się</button>
            </div>
            
        </header>
    )
}
export default Header